import { IEventAggregationService, ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { FavouriteApplicationStatusChanged, FavouriteRemoved } from '@studyportals/wishlist-service-core';
import { WishlistCache } from '../infrastructure/wishlist-cache';

export class WebsocketFavouriteApplicationStatusChangedSubscriber
	implements ISubscriber<FavouriteApplicationStatusChanged>
{
	constructor(
		private readonly eventAggregationService: IEventAggregationService,
		private wishlistCache: WishlistCache,
	) {}

	async notify(event: FavouriteApplicationStatusChanged): Promise<void> {
		await this.updateFavourite(event);
		const isLocalEvent = this.wishlistCache.isStateHashLocal(event.stateHash);

		this.eventAggregationService.publishTo(
			FavouriteApplicationStatusChanged.EventType,
			new FavouriteApplicationStatusChanged(
				event.userId,
				event.studyId,
				event.applicationStatus,
				event.eventId,
				event.stateHash,
				new Date(event.timestamp),
				isLocalEvent,
			),
		);
	}

	private async updateFavourite(event: FavouriteApplicationStatusChanged): Promise<void> {
		const wishlist = await this.wishlistCache.getWishlist();
		if (wishlist) {
			const favourite = wishlist.findFavourite(event.studyId);
			if (!favourite) {
				return;
			}

			favourite.setApplicationStatus(event.applicationStatus);
			await this.wishlistCache.setWishlist(wishlist);
		}
	}
}
